"use client"
import styled from "@emotion/styled"
import { DonationMessages } from "app/[locale]/(layout)/donation-application-form/page"
import { useEffect, useRef } from "react"
import "swiper/css"
import { Container, NewText } from "ui"
import { extractProperty } from "utils"
import RadioButtonController from "./form/RadioButtonController"

const StyledContainer = styled.div`
  margin-top: 32px;
  scroll-margin-top: 80px;
  background: white;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 40px;
    scroll-margin-top: 120px;
  }
`
type Props = {
  data: any
  control: any
  messages: DonationMessages
}

export const MainHeader: React.FC<Props> = ({ data, control, messages }) => {
  const title = extractProperty(data, "mainTitle")
  const headerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (headerRef.current) {
      headerRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }, [])

  return (
    <Container>
      <StyledContainer ref={headerRef}>
        <NewText
          desktopFontSize={32}
          desktopFontWeight="400"
          desktopLineHeight="36px"
          mobileFontSize={24}
          mobileFontWeight="400"
          mobileLineHeight={"28px"}
          component="h1"
          color={"black"}
        >
          {title}
        </NewText>
      </StyledContainer>
      <RadioButtonController
        no={messages.no}
        yes={messages.yes}
        title={messages.doYouCompl}
        desktopFontSize={18}
        mobileFontSize={16}
        control={control}
        name="IsDonationPolicy"
      />
    </Container>
  )
}
export default MainHeader
